import { useEffect, useMemo, useState } from "react";

import { parseUrlFragment, ViewerPrefs } from "./url-fragment";

export function useParsedInitialView({
  urlFragment,
  versionId,
  initialView,
}: {
  urlFragment: string | undefined;
  versionId: string | undefined;
  initialView: ViewerPrefs | undefined;
}) {
  const currentHash = useCurrentHash();

  // Parse URL fragment to ViewerPrefs (prioritize currentHash/urlFragment over initialView)
  return useMemo(() => {
    const effectiveFragment = currentHash || urlFragment;
    if (effectiveFragment && versionId) {
      return parseUrlFragment(effectiveFragment, versionId);
    }
    return initialView;
  }, [currentHash, urlFragment, versionId, initialView]);
}

function useCurrentHash() {
  // Listen to actual hash changes from window.location (for cases where replaceState is used)
  const [currentHash, setCurrentHash] = useState(() => window.location.hash?.slice(1) || "");

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash?.slice(1) || "");
    };

    window.addEventListener("hashchange", handleHashChange);

    const intervalId = setInterval(() => {
      const newHash = window.location.hash.slice(1);
      if (newHash !== currentHash) {
        setCurrentHash(newHash);
      }
    }, 100);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
      clearInterval(intervalId);
    };
  }, [currentHash]);
  return currentHash;
}
